// extracted by css-extract-rspack-plugin
export default {"previousButtonIcon":"src-domain-components-system-package-version-steps-systemPackageVersionSteps-module__previousButtonIcon-JnPMJh","actionContainer":"src-domain-components-system-package-version-steps-systemPackageVersionSteps-module__actionContainer-gAFJ86","container":"src-domain-components-system-package-version-steps-systemPackageVersionSteps-module__container-aHF4yv"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"previousButtonIcon\":\"src-domain-components-system-package-version-steps-systemPackageVersionSteps-module__previousButtonIcon-JnPMJh\",\"actionContainer\":\"src-domain-components-system-package-version-steps-systemPackageVersionSteps-module__actionContainer-gAFJ86\",\"container\":\"src-domain-components-system-package-version-steps-systemPackageVersionSteps-module__container-aHF4yv\"}";
        // 1792611262791
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  